import React from 'react';
import { components, type SelectComponentsConfig } from '@atlaskit/select';
import type { OptionValue } from '../../types.tsx';

const Control: SelectComponentsConfig<OptionValue>['Control'] = ({ children, ...rest }) => (
	<div data-testid={`${rest.selectProps.testId}--control`}>
		<components.Control {...rest}>{children}</components.Control>
	</div>
);

const Option: SelectComponentsConfig<OptionValue>['Option'] = ({ children, ...rest }) => (
	<div data-testid={`${rest.selectProps.testId}--option`}>
		<components.Option {...rest}>{children}</components.Option>
	</div>
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default {
	Control,
	Option,
};
